import Vue from 'vue'
import App from '@/App.vue'
import mixins from '@/mixins.js'
import router from '@/router'
import store from '@/store'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

import VueMasonry from 'vue-masonry-css'

Vue.use(VueMasonry)

import VueFlags from '@growthbunker/vueflags'

Vue.use(VueFlags, {
  iconPath: 'flags/',
})

Vue.config.productionTip = false

import '@/lib/components'
import '@/lib/font'
import '@/lib/icons'
import '@/lib/interceptors'
import '@/lib/authentication'

new Vue({
  mixins: [mixins],
  router,
  store,
  render: h => h(App)
}).$mount('#app')
